import React from 'react';
import PageLayout from '../../../global/partialBase/pageLayout';
import LabelsByDateBody from './body';

const LabelsByDate = () => {
    return (
        <div>
            <PageLayout tabMenu={true} body={<LabelsByDateBody />} selectedItem="Labels by Date" />
        </div>
    );
};

export default LabelsByDate;
